import { useMemo } from 'react'
import { usePlan } from '~/app/plan-context'
import { planLimits } from '../plans'

interface ListingGate {
  isUnlimited: boolean
  used: number
  max: number
  atLimit: boolean
  canCreate: boolean
  isLoading: boolean
}

export function useListingGate(): ListingGate {
  const { tier, usage, isLoading, isAdminBypassing } = usePlan()

  return useMemo(() => {
    const max = isAdminBypassing ? -1 : planLimits[tier].maxListings
    const used = usage.listings
    const isUnlimited = max === -1

    if (isLoading || (!isUnlimited && max <= 0)) {
      return {
        isUnlimited,
        used,
        max,
        atLimit: false,
        canCreate: true,
        isLoading,
      }
    }

    const atLimit = !isUnlimited && used >= max

    return {
      isUnlimited,
      used,
      max,
      atLimit,
      canCreate: !atLimit,
      isLoading,
    }
  }, [tier, usage.listings, isLoading, isAdminBypassing])
}
